/*
 * @Author: Dong
 * @Date: 2022-04-07 13:40:11
 * @LastEditors: zhang lin
 * @LastEditTime: 2022-12-06 13:16:56
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  placeholder: '请选择',
  placeholderInput: '请选择',
  timeZone: '时区',
  setTime: '设置时间',
  manual: '手动的',
  auto: '自动使用指定的NTP服务器',
  time: '时间',
  NTP: 'NTP服务器',
  title: '扩容节点',
  rules: '格式不正确',
  tip: '选择的时间不能小于当前系统时间',
  host: '主机名称',
  nodeType: '节点类型',
  success: '扩容成功',
});
